export enum IframeWrapperAction {
    CANCELLED = 'CANCELLED',
    SUCCESS = 'SUCCESS',
    DECLINED = 'DECLINED',
    OPENED = 'OPENED',

    // a message type that commands to close the payment widget
    CLOSE_WIDGET = 'CLOSE_WIDGET'
}
